import React, { useEffect, useState } from 'react';

import validate from '../validators/validateTextMultiple';
import QuestionText from './QuestionText';

const QuestionFormTextMultiple = ({
  focus,
  question,
  savedAnswer,
  variables,
  onChange,
  children,
}) => {
  const { options } = question;
  const initialStateMap = savedAnswer || {};
  const [stateMap, setStateMap] = useState(initialStateMap);

  const handleChange = (key, value) => {
    const list = {
      ...stateMap,
      ...{
        [key]: value
      }
    }
    setStateMap(s => ({ ...s, [key]: value }));
    onChange(question.key, list, validate);
  };

  return (
    <div>
      {options.map((option, index) => (
        <QuestionText
          autoFocus={focus && index === 0}
          key={option.key}
          option={option}
          variables={variables}
          answer={stateMap[option.key]}
          onChange={event => handleChange(option.key, event.target.value)}
        />
      ))}
      {children}
    </div>
  );
};

export default QuestionFormTextMultiple;
